<template>
  <!-- 专业开设院校 -->
  <div class="page" style="overflow: hidden;">
    <div class="grid-content bg-purple record">
      <div class="generalBg_Virtualization"></div>
      <div class="page" style="overflow: hidden;">
        <div class="header">
          <div class="header_Virtualization"></div>
          <div class="header_title">
            <i class="h_icon header-icon"></i>
            <span style="margin-right:20px;">专业开设院校</span>
          </div>
          <i class="threePoints el-icon-more"></i>
        </div>
        <div class="standards_content" style="position: relative;">
          <div ref="universitiesAndColleges" id="universities"></div>

          <div class="sidePage" v-if="isSidePage" onmouseleave="removes()">
            <ul>
              <li v-for="(item,index) in coursesList" :key="index" style="line-height: 30px">
                <p class="schoolName" style="font-size: 20px;color: white">{{item.schoolName}}</p>
                <p style="color: white">本专业开设课程：</p>
                <p class="openCourses">{{item.courseSetUpInfo == null?'暂无':item.courseSetUpInfo}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
require("echarts/extension/bmap/bmap");
import baiduAndCloudStyle from "../../../public/baiduAndCloudStyle"
import city from '../../../public/city'

export default {
  data() {
    return {
      datas: [],
      isSidePage: false,
      coursesList: []
    }
  },
  mounted() {
    this.setPieOption(this.$refs.universitiesAndColleges)

    // 点击tooltip中的省份显示
    const that = this
    window.myDialog = function (title) {
      that.isSidePage = true
      that.$axios.post(that.$apiurls.institutions_getSchoolSetUpCourses, title, {
        loading: false,
      }).then((res) => {
        if (res) {
          that.coursesList = res.data
          console.log(res);
        }
      })
    }

    // 移出后隐藏
    window.removes = function () {
      that.isSidePage = false
    }
  },
  methods: {
    setPieOption(provinceOrCollege) {
      var that = this
      this.$axios.post(that.$apiurls.institutions_getProfessionSetUpSchools, {
        loading: false,
      }, { timeout: 3 * 60 * 1000 }).then((res) => {
        if (res) {
          var dataList = JSON.stringify(res.data)
          dataList = JSON.parse(dataList)

          if (dataList.length >= 1) {
            dataList = dataList.sort(function (a, b) { return b.schoolList.length - a.schoolList.length });   //排序

            that.pieEcharts = that.$echarts.init(provinceOrCollege);
            var collegesList = []
            const geoCoordMap = city.getCity()
            for (var i = 0; i < dataList.length; i++) {     //把地图点的坐标值塞到了数据里面
              var geoCoord = geoCoordMap[dataList[i].name];
              if (geoCoord) {
                collegesList.push({
                  name: dataList[i].name,
                  value: geoCoord.concat(dataList[i].value),
                  schoolList: dataList[i].schoolList,
                  isSelect: i < 5 ? true : false    //找出前5个最多的学校进行切换图标
                });
              }
            }

            var arrList = []
            for (let i = 0; i < collegesList.length; i++) {
              var obj = {}
              obj = {
                type: 'scatter',
                coordinateSystem: 'bmap',
                data: [collegesList[i]],
                symbolSize: 10,
                itemStyle: {   // 地图区域的配置
                  normal: {
                    areaColor: '#fff',  // 绘制的每一个轮廓的背景颜色
                    borderColor: '#fff',
                    backgroundColor: "#fff",
                    color: '#348BE7',   //设置散点的颜色
                    shadowBlur: 10,
                    shadowColor: '#333',
                  },
                  emphasis: {
                    areaColor: '#2a333d',// 鼠标移到区域时的背景颜色
                  },
                },
                showEffectOn: 'render',
                rippleEffect: {
                  brushType: 'stroke'
                },
                label: {
                  formatter: '{b}',
                  position: 'right',
                  show: true,
                  color: '#767E8B',
                  fontSize: 14,
                  fontWeight: '700'
                },
                symbol: collegesList[i].isSelect ? baiduAndCloudStyle.greenBase() : baiduAndCloudStyle.blueBase(), //设置散点的点形状
                symbolSize: collegesList[i].isSelect ? [20, 23] : [13, 15], //设置散点的点大小
                emphasis: {
                  scale: true,
                },
                zlevel: 1
              }
              arrList.push(obj)
            }
            arrList = JSON.stringify(arrList)

            that.pieOption = {
              bmap: {
                roam: true,  //是否开启缩放和拖动
                mapStyle: { //地图样式
                  styleJson: baiduAndCloudStyle.baiduMapStyle1()
                }
                // mapStyle: { //地图样式
                //   styleJson: baiduAndCloudStyle.baiduMapStyle2()
                // }
              },
              tooltip: {
                trigger: "item",
                show: true,
                enterable: true,  //鼠标是否可进入提示框浮层中
                extraCssText: 'max-width:60%;max-height:250px;overflow:auto;',
                textStyle: {
                  fontSize: 15,
                  color: "#fff",
                },
                // backgroundColor: "rgba(9,16,41,0.5)",
                backgroundColor: "rgba(64, 80, 118, 0.8)", //通过设置rgba调节背景颜色与透明度
                borderColor: 'rgba(64, 80, 118, 0.8)',
                formatter: (name) => {
                  var stringText = ''
                  stringText += `<i class='icon-circular' style="width:15px;height:15px;display: inline-block;color: #1CEBEE;"></i> ${name.data.name}  <br/>`
                  for (let i = 0; i < name.data.schoolList.length; i++) {
                    stringText += `${name.data.schoolList[i]}  <br/>`
                  }
                  return `<div onclick="myDialog('${name.data.name}')">${stringText}</div>`
                },
              },
              // backgroundColor: {
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 1,
              //   y2: 1,
              //   colorStops: [{
              //     offset: 0, color: 'rgba(22,29,54,1)' // 0% 处的颜色
              //   }, {
              //     offset: 0.5, color: 'rgba(9,16,41,0.3)' // 50% 处的颜色
              //   }, {
              //     offset: 1, color: 'rgba(22,29,54,1)' // 100% 处的颜色
              //   }],
              //   globalCoord: false // 缺省为 false
              // },
              series: JSON.parse(arrList),
            };
            // 渲染图表
            that.pieEcharts.setOption(that.pieOption);
            var bmap = that.pieEcharts.getModel().getComponent('bmap').getBMap();
            bmap.centerAndZoom(new BMap.Point(116.413384, 39.910925), 5); //初始化地图位置点，以及缩放程度
            that.pieEcharts.on("finished", () => {
              bmap.disableDoubleClickZoom();
            })
            window.addEventListener('resize', () => {
              this.pieEcharts.resize();
            })

            bmap.setMinZoom(5)  //设置地图最小缩放范围
            bmap.setMaxZoom(8)  //设置地图最大缩放范围


            // bmap.addEventListener('click', function (e) {
            //   console.log('点击位置经纬度：', e, e.currentTarget.re);
            //   // bmap.centerAndZoom(e.currentTarget.bh, 9);// 设置地图显示的城市 此项是必须设置的，以及设置当前位置的缩放程度
            // });
          }
        }
      });
    },
  }
}
</script>

<style  lang="scss" src="@/assets/css/custom.scss" scoped></style>
<style scoped>
ul,
li,
p {
  padding: 0px;
  margin: 0px;
  list-style: none;
}
#universities {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
}

.sidePage {
  width: 25%;
  height: 90%;
  border-radius: 8px;
  padding: 15px;
  overflow-y: auto;
  white-space: normal;
  word-wrap: break-word;
  position: absolute;
  right: 10px;
  top: 10px;
  background: rgba(0, 0, 0, 0.5);
}

ul {
  width: 100%;
  height: auto;
  color: #bcc2cf;
}

.sidePage_title {
  font-size: 20px;
  color: #fff;
  margin-bottom: 10px;
}

.schoolName {
  font-size: 15px;
}

.openCourses {
  font-size: 13px;
  margin: 5px 0px 30px;
}

li:last-child > .openCourses:last-child {
  margin-bottom: 0px;
}
</style>
